import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const IntroBlurb = () => {
  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-5">
            Wait, a Real Island?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground mb-4">
            Yes, Son's Island is an actual island with 3.5 private acres on Lake Placid in Seguin, Texas — you literally cross a bridge to get here. Reserve your own lakeside cabana with a private dock, paddle out on kayaks and paddleboards, swim, grill, hit the rope swing, fly down the frog slide.
          </p>
          <p className="text-base md:text-lg text-muted-foreground mb-8">
            Just 11 miles from New Braunfels, about 45 minutes from San Antonio, and about an hour from Austin, it's the kind of slow, sunlit day your family and friends will talk about for years.
          </p>
          <div className="flex justify-center">
            <Button variant="hero" size="lg" asChild>
              <Link to="/book-now">Check Availability</Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default IntroBlurb;